import { ref, onMounted, onUnmounted } from "vue";

export function useInfiniteScroll(callback, canLoadMore) {
  const isFetching = ref(false);
  const observer = ref(null);
  const loadMoreTrigger = ref(null);

  const startObserving = () => {
    if (!loadMoreTrigger.value) return;

    observer.value = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !isFetching.value && canLoadMore()) {
        isFetching.value = true;
        callback().finally(() => {
          isFetching.value = false;
        });
      }
    });

    observer.value.observe(loadMoreTrigger.value);
  };

  onMounted(startObserving);
  onUnmounted(() => observer.value?.disconnect());

  return { loadMoreTrigger, isFetching };
}
